<i18n locale="en">
  {
    "title": {
      "single": "Our location",
      "multi": "Our locations"
    }
  }
</i18n>

<template>
  <PreviewSheet class="locations-preview w-full h-full" radius="0">
    <div class="flex-col gap-4">
      <div class="flex-col gap-12">
        <div class="flex-row justify-between align-center">
          <PreviewTypography :text="title" variant="heading2" />
          <LocationsPreviewNavButtons v-if="multiLoc" />
        </div>
        <LocationsPreviewPillSelector v-if="multiLoc" />
      </div>
      <LocationsPreviewInfoSheet
        v-if="firstLocation"
        :location="firstLocation"
      />
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { type Location } from '@/core/types'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'
import { useMappedGetter } from '@/store'

import type { LocationsSection } from '../../../WebsiteBuilder.types'

import LocationsPreviewInfoSheet from './LocationsPreviewInfoSheet.vue'
import LocationsPreviewNavButtons from './LocationsPreviewNavButtons.vue'
import LocationsPreviewPillSelector from './LocationsPreviewPillSelector.vue'

defineProps<{
  content: LocationsSection
}>()

const activeLocations = useMappedGetter<Location[]>(
  'core/brand/active/locations'
)

const multiLoc = computed(() => activeLocations.value.length > 1)

const { t } = useI18n()

const title = computed(() => {
  return t(multiLoc.value ? 'title.multi' : 'title.single')
})

const firstLocation = computed(() => activeLocations.value[0])
</script>

<style lang="scss" scoped>
.locations-preview {
  padding: 120px;
}
</style>
